import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './removecommitte.css';

function RemoveCommittee() {
    const [committees, setCommittees] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCommittees();
    }, []);

    const fetchCommittees = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/committee`);
            setCommittees(response.data);
        } catch (error) {
            console.error('Error fetching committees:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch committees',
                confirmButtonColor: '#5e71f6',
            });
        } finally {
            setLoading(false);
        }
    };

    const removeCommittee = async (id, committeeName) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            html: `Do you want to remove the committee <strong>"${committeeName}"</strong>?<br><span style="color: #dc2626; font-size: 0.9rem;">This action cannot be undone!</span>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#94a3b8',
            confirmButtonText: '<span style="display: flex; align-items: center; gap: 8px;"><svg style="width: 18px; height: 18px;" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg> Yes, Remove It!</span>',
            cancelButtonText: 'Cancel',
            customClass: {
                popup: 'modern-swal-popup',
                confirmButton: 'modern-swal-confirm-danger',
                cancelButton: 'modern-swal-cancel'
            },
        });

        if (result.isConfirmed) {
            try {
                await axios.delete(`${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/remove/committe/${id}`);
                Swal.fire({
                    icon: 'success',
                    title: 'Removed!',
                    text: 'The committee has been removed successfully.',
                    confirmButtonColor: '#5e71f6',
                });
                setCommittees(committees.filter(committee => committee._id !== id));
            } catch (error) {
                console.error('Error removing committee:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to remove the committee. Please try again.',
                    confirmButtonColor: '#5e71f6',
                });
            }
        }
    };

    return (
        <div className="remove-committee-wrapper">
            <div className="remove-committee-container">
                {/* Header Section */}
                <div className="remove-committee-header">
                    <h1 className="remove-committee-title">Remove Committee</h1>
                    <p className="remove-committee-subtitle">Manage and remove existing committees</p>
                </div>

                {/* Committee List Card */}
                <div className="committee-list-card">
                    <div className="committee-list-header">
                        <h2 className="committee-list-title">
                            <svg className="header-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                            </svg>
                            Committee List
                        </h2>
                        <span className="committee-count-badge">
                            {committees.length} {committees.length === 1 ? 'Committee' : 'Committees'}
                        </span>
                    </div>

                    <div className="committee-list-content">
                        {loading ? (
                            <div className="loading-state">
                                <svg className="loading-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                <p>Loading committees...</p>
                            </div>
                        ) : committees.length === 0 ? (
                            <div className="no-committees-message">
                                <svg className="no-committees-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                                </svg>
                                <p>No committees found.</p>
                                <span className="no-committees-subtext">All committees have been removed or none have been created yet.</span>
                            </div>
                        ) : (
                            <div className="committees-grid">
                                {committees.map((committee, index) => (
                                    <div className="committee-card-item" key={committee._id}>
                                        <div className="committee-card-content">
                                            <div className="committee-number-badge">
                                                <svg className="badge-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                                </svg>
                                                #{index + 1}
                                            </div>
                                            
                                            <div className="committee-info-section">
                                                <div className="committee-name-row">
                                                    <svg className="committee-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                                    </svg>
                                                    <h3 className="committee-name-text">
                                                        {committee.mainCommittee.committeeName}
                                                    </h3>
                                                </div>
                                                
                                                {committee.mainCommittee.members && committee.mainCommittee.members.length > 0 && (
                                                    <div className="committee-members-info">
                                                        <svg className="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                                        </svg>
                                                        <span className="members-count">
                                                            {committee.mainCommittee.members.length} {committee.mainCommittee.members.length === 1 ? 'Member' : 'Members'}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <button 
                                            className="remove-committee-button" 
                                            onClick={() => removeCommittee(committee._id, committee.mainCommittee.committeeName)}
                                            title="Remove this committee"
                                        >
                                            <svg className="button-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                            </svg>
                                            Remove Committee
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RemoveCommittee;
